import { render, staticRenderFns } from "./BlockModal.vue?vue&type=template&id=a2d6abcc"
import script from "./BlockModal.vue?vue&type=script&lang=js"
export * from "./BlockModal.vue?vue&type=script&lang=js"
import style0 from "./BlockModal.vue?vue&type=style&index=0&id=a2d6abcc&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports